/**
 * Plain string formatting for paper-journal identifiers (no locale thousands separators).
 */

export function formatPaperJournalPlainInt(value: number | string | bigint): string {
  return String(value);
}

/**
 * True when EPID is a positive decimal integer (no leading zeros).
 * Tenant-hash EPIDs return false. Detail and paper-journal links accept both.
 */
export function isPaperJournalNumericEpid(value: string | number): boolean {
  if (typeof value === 'number') {
    return Number.isInteger(value) && value > 0;
  }
  const token = value.trim();
  return /^[1-9]\d*$/.test(token);
}
